module.exports = __webpack_public_path__ + "static/media/wt-institution3.a3ab16c3.png";